import React from "react";
import ReactDOM from "react-dom/client";
import { WhyCastLanding } from "./WhyCastLanding";
import "./styles.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <WhyCastLanding />
  </React.StrictMode>,
);
